import { authClient, authQueryClient } from '@metto/http-clients/api';

export const verifySession = () => {
  return authQueryClient.fetchQuery({
    queryKey: ['auth', 'session'],
    queryFn: () => authClient.getSession()
  });
};
